<template>
  <div>
    <!-- Header Filter & Suchen -->
    <div class="bg-custom-blue">
      <div class="container">
        <div class="row py-2">

          <!-- Suche nach Document-Name  -->
          <div class="col-2">
            <input v-model="filterName" type="text" class="form-control form-select-sm" :placeholder='$t("general.placeholderSearch")'>
          </div>

          <!-- Filter Category   -->
          <div class="col-2">
            <select v-model="filterCategory" class="form-select form-select-sm">
              <option value="">{{ $t("views.downloads.allCategories") }}</option>
              <option v-for="cat in uniqueCategories" :key="cat" :value="cat"> {{ cat }} </option>
            </select>
          </div>

          <!-- Filter Culture   -->
          <div class="col-2">
            <select v-model="filterCulture" class="form-select form-select-sm">
              <option value="">{{ $t("views.downloads.allCultures") }}</option>
              <option v-for="cul in uniqueCultures" :key="cul" :value="cul"> {{ cul }} </option>
            </select>
          </div>

        </div>
      </div>
    </div>

    <div v-if="documentsArray.length" class="container my-3">
      <!-- Title & Infobutton-->
      <div class="row">
        <div class="col-12">
          <div class="h4 px-1">
            {{ $t("views.nav.downloads") }}
          </div>
        </div>
      </div>

      <div class="bg-white rounded-2 p-2 mt-3">

        <!-- Header -->
        <div class="row">
          <div class="col-12">
            <div class="">
              <div class="row fw-bold px-3 border-bottom py-2">
                <div class="col-2 px-1">
                  {{ $t("views.downloads.name") }}
                </div>
                <div class="col-7 px-1">
                  {{ $t("views.downloads.description") }}
                </div>
                <div class="col-1 text-start px-1">
                  {{ $t("views.downloads.category") }}
                </div>
                <div class="col-1 text-start px-1">
                  {{ $t("views.downloads.culture") }}
                </div>
                <div class="col-1 text-start px-1">
                  {{ $t("views.downloads.link") }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Content-->
        <div class="row">
          <div class="col-12">
            <div v-for="doc in filteredDocuments" :key="doc.id" class="row px-3 border-bottom">
                <div class="col-2 my-auto col-measure-name px-1 py-2">
                  {{ doc.name }}
                </div>
                <div class="col-7 text-start px-1 py-2">
                  {{ doc.description }}
                </div>
                <div class="col-1 text-start px-1 py-2">
                  {{ doc.category }}
                </div>
                <div class="col-1 text-start px-1 py-2">
                  {{ doc.culture }}
                </div>
                <div class="col-1 text-center px-1 py-2">
                  <svg class="bi" width="16" height="16" fill="currentColor" style="cursor:pointer" @click="downloadFile(doc)" > <use xlink:href="@/assets/icons/icons.svg#download" /> </svg> &nbsp;
                </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- No Data -->
    <div v-else-if="!loadingStatus" class="text-center mt-5">
      <img src="@/assets/img/no_data.svg" class="img-fluid" width="250">
      <p class="h5 mt-3">{{ $t("views.my.tasks.noTasks") }}.</p>
    </div>

  </div>
</template>

<script>
import * as formatUtils from '../../composables/formatUtils'

export default {
  name: 'DownloadDocuments',

  data () {
    return {
      filterName: '',
      filterCategory: '',
      filterCulture: '',
      documentsArray: []
    }
  },

  computed: {
    filteredDocuments () {
      return this.documentsArray.filter(doc => {
        const matchesName =
          doc.name.toLowerCase().includes(this.filterName.toLowerCase())

        const matchesCategory =
          !this.filterCategory || doc.category === this.filterCategory

        const matchesCulture =
          !this.filterCulture || doc.culture === this.filterCulture

        return matchesName && matchesCategory && matchesCulture
      })
    },
    uniqueCategories () {
      const cats = this.documentsArray.map(d => d.category).filter(Boolean)
      return [...new Set(cats)]
    },
    uniqueCultures () {
      const cul = this.documentsArray.map(d => d.culture).filter(Boolean)
      return [...new Set(cul)]
    },
    loadingStatus () {
      return this.$store.state.loadingStatus
    }
  },

  watch: {
    // userLocale als Default setzen
    uniqueCultures: {
      immediate: true,
      handler (list) {
        const userLocale = this.$store.state.user.settings?.language
        if (list && list.length > 0 && list.includes(userLocale) && !this.filterCulture) {
          this.filterCulture = userLocale
        }
      }
    }
  },

  methods: {
    async downloadFile (doc) {
      this.$store.commit('SET_LOADING_STATUS', true)
      const blob = await this.$store.dispatch('getDocumentDownload', doc.id)
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = doc.link.replace('mao/docs/', '') // Nur Dateiname ohne Pfad
      a.click()
      window.URL.revokeObjectURL(url)
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    formatPeriod (period) {
      return formatUtils.formatPeriod(period)
    },
    formatDate (date) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.formatDate(userLocale, date)
    }
  },
  async created () {
    this.$store.commit('SET_LOADING_STATUS', true)
    this.documentsArray = await this.$store.dispatch('getDocuments')
    this.$store.commit('SET_LOADING_STATUS', false)
  }
}
</script>
